import { render, staticRenderFns } from "./FStep.vue?vue&type=template&id=13ff876c&"
import script from "./FStep.vue?vue&type=script&lang=js&"
export * from "./FStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports